import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { API_URL } from "../api/index";

const ResetPassword = ({ onGoBack }) => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const token = params.get("token") || "";

  const [password, setPassword] = useState("");
  const [msg, setMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMsg("");
    try {
      await axios.post(`${API_URL}/reset/confirm`, {
        token,
        new_password: password,
      });
      setMsg("¡Contraseña actualizada correctamente! Ya puedes iniciar sesión.");
      setTimeout(() => {
        onGoBack && onGoBack();
      }, 2000);
    } catch (error) {
      setMsg("El enlace no es válido o ha expirado.");
    }
    setLoading(false);
  };

  if (!token) {
    return (
        <div className="flex items-center justify-center min-h-screen bg-gray-50">
          <div className="w-full max-w-md p-8 bg-white rounded-2xl shadow-xl text-center">
            <h2 className="text-2xl font-bold mb-6">Error</h2>
            <div className="text-red-700 bg-red-100 rounded-xl p-3">
              El enlace no es válido o ha expirado. Solicita un nuevo reseteo.
            </div>
            <button
                onClick={onGoBack}
                className="w-full mt-6 text-blue-600 hover:underline text-center"
            >
              Volver al login
            </button>
          </div>
        </div>
    );
  }

  return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <div className="w-full max-w-md p-8 bg-white rounded-2xl shadow-xl">
          <h2 className="text-2xl font-bold mb-6 text-center">Elige una nueva contraseña</h2>
          <form onSubmit={handleSubmit} className="flex flex-col gap-4">
            <input
                type="password"
                placeholder="Nueva contraseña"
                value={password}
                onChange={e => setPassword(e.target.value)}
                required
                className="border rounded-xl px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <button
                type="submit"
                disabled={loading}
                className="bg-blue-600 hover:bg-blue-700 text-white rounded-xl py-2 font-semibold transition disabled:bg-blue-300"
            >
              {loading ? "Actualizando..." : "Actualizar contraseña"}
            </button>
          </form>
          {msg && (
              <div className={`mt-6 text-center text-sm ${msg.includes('correctamente') ? 'text-green-700 bg-green-100' : 'text-red-700 bg-red-100'} rounded-xl p-3`}>
                {msg}
              </div>
          )}
          <button
              onClick={onGoBack}
              className="w-full mt-6 text-blue-600 hover:underline text-center"
          >
            Volver al login
          </button>
        </div>
      </div>
  );
};

export default ResetPassword;